import request from '@/utils/request.js';
// 判断微信授权
export const is_Auth = () => request({ url: '/v1/user/auth', method: 'get' });
// 微信授权
export const wx_login = (data) => request({ url: '/v1/wx/login', method: 'post', data });
// 绑定（换绑）游戏账号/登录
export const gameAccountBind = (data) =>
  request({ url: '/v1/game_account/bind', method: 'post', data, showToast: true });